// src/Profil/useTheme.js
import { useEffect, useState } from "react";

const THEME_KEY = "app-theme";

// Immediately apply stored theme (or system preference) on first JS load.
// This runs before React renders, so refresh will keep the mode visually.
(function bootstrapTheme() {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const stored = window.localStorage.getItem(THEME_KEY);
    if (stored === "light" || stored === "dark") {
        document.documentElement.setAttribute("data-theme", stored);
        return;
    }

    const prefersDark =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;

    document.documentElement.setAttribute("data-theme", prefersDark ? "dark" : "light");
})();

export function useTheme() {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "light";

        const stored = window.localStorage.getItem(THEME_KEY);
        if (stored === "light" || stored === "dark") return stored;

        const prefersDark =
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches;

        return prefersDark ? "dark" : "light";
    });

    useEffect(() => {
        if (typeof document === "undefined") return;
        document.documentElement.setAttribute("data-theme", theme);
        window.localStorage.setItem(THEME_KEY, theme);
    }, [theme]);

    return { theme, setTheme };
}
